/* eslint-disable react/prop-types */
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Typography } from '@applyboard/ui-components';
import { APPLYPROOF_ICON, STUDENT_RECORDS_ICON } from "../../../../util/cdnAssets";
import { TAG_ID_MAPPING } from "./consts";
import { TagWrapper } from "./style";
var Tag = function Tag(_ref) {
  var tagId = _ref.tagId;
  var color = null;
  var backgroundColor = null;
  if (tagId in TAG_ID_MAPPING) {
    color = TAG_ID_MAPPING[tagId].theme.color;
    backgroundColor = TAG_ID_MAPPING[tagId].theme.backgroundColor;
  }
  return /*#__PURE__*/React.createElement(TagWrapper, {
    color: color,
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(TagContent, {
    tagId: tagId
  }));
};
function TagContent(_ref2) {
  var tagId = _ref2.tagId;
  if (tagId === 'applyproof_compatible') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      src: APPLYPROOF_ICON,
      alt: "This requirement is Applyproof Compatible.",
      "data-tip": TAG_ID_MAPPING[tagId].title,
      "data-for": "compare-modal-tooltip"
    }), /*#__PURE__*/React.createElement(ReactTooltip, {
      id: "compare-modal-tooltip"
    }));
  }
  if (tagId === 'student_records') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      src: STUDENT_RECORDS_ICON,
      alt: "This requirement will show up on Student Records.",
      "data-tip": TAG_ID_MAPPING[tagId].title,
      "data-for": "compare-modal-tooltip"
    }), /*#__PURE__*/React.createElement(ReactTooltip, {
      id: "compare-modal-tooltip"
    }));
  }
  if (tagId in TAG_ID_MAPPING) {
    return /*#__PURE__*/React.createElement(Typography, null, TAG_ID_MAPPING[tagId].title);
  }
  return null;
}
export default /*#__PURE__*/React.memo(Tag);